// extracted by mini-css-extract-plugin
export default {"finePrint":"SmallPrint_finePrint__GQgso marketplaceTinyFontStyles","setLowerCase":"SmallPrint_setLowerCase__ZKlnc"};